import { Controller } from "react-hook-form";
import { FieldProps } from "../renderFieldInput";
import { Select, MenuItem, FormControl, FormHelperText, InputLabel } from "@mui/material";
import { useEffect, useRef } from "react";

interface SelectInputFieldProps extends FieldProps {}

export const SelectInputField = ({ field, value, entityForm, options, extraOptions }: SelectInputFieldProps) => {
    let initialValue: any;

    if (field.settings.interface === "select-multiple-dropdown") {
        initialValue = value ? value : [];
    } else {
        initialValue = value ? value : "";
    }

    const isRequired = field.settings.required || false;
    const isMultiple = field.settings.interface === "select-multiple-dropdown";
    const hasInitializedRef = useRef(false);

    useEffect(() => {
        if (hasInitializedRef.current) return;
        hasInitializedRef.current = true;

        if (extraOptions?.defaultValue && !initialValue) {
            entityForm.setValue(field.field, extraOptions?.defaultValue);
        } else {
            const formValue = entityForm.getValues(field.field);
            if (formValue !== initialValue) {
                entityForm.setValue(field.field, initialValue);
            }
        }
    }, [initialValue]);

    return (
        <Controller
            name={extraOptions?.field ? extraOptions?.field : field.field}
            control={entityForm.control}
            defaultValue={initialValue || extraOptions?.defaultValue || ""}
            render={({ field: inputField }) => {
                return (
                    <FormControl fullWidth error={options?.error}>
                        <InputLabel required={isRequired}>{field.headerName}</InputLabel>
                        <Select
                            {...inputField}
                            required={isRequired}
                            disabled={options?.disabled}
                            label={field.headerName}
                            multiple={isMultiple}
                            onChange={(event) => {
                                const newValue = event.target.value;
                                if (isMultiple && Array.isArray(newValue) && newValue.includes("")) {
                                    inputField.onChange([]);
                                    return;
                                }
                                inputField.onChange(event);
                            }}
                        >
                            <MenuItem value="">Remover {field.headerName}</MenuItem>
                            {field.settings?.options?.choices
                                ?.filter((choice) => !extraOptions?.allowedChoices || extraOptions.allowedChoices.includes(choice.value))
                                ?.map((choice) => {
                                return (
                                    <MenuItem key={choice.value} value={choice.value}>
                                        {choice.text}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                        <FormHelperText>{options?.helperText}</FormHelperText>
                    </FormControl>
                );
            }}
        />
    );
};
